/**
 * Classe que cria e gerencia a janela de modal
 * @author: Daniel Laurindo
 * @Date: 05/06/2013
 *
 */

import { DefaultRequest } from 'scripts/api';

/**
 * Cria uma função que se torna recipiente de qualquer outra estrtura para montar um modal contendo
 * qualquer tipo de informação. Exemplos: ( formulario de cadastro, visualizador de imagens, galeria de imagens ou videos, etc...)
 *
 * @params    {string}            - selector                : Aba em que a toolbar sera plotada
 * @params    {string}            - scopeBlock            : Elemento responsovel por bloquear outros elementos por tres da Janela de Modal.
 * @params  {integer ou string} - width                : Largura da janela de modal
 * @params  {integer ou string} - height                : Altura da janela de modal
 * @params  {function}            - callbackCreateForm    : Funcao que deve possuir uma estrutura html para produzir o tipo de informacao ou layout dentro do modal.
 *
 */
Monet.GenericModal = function () {

    this.modalForm = null;
    this.obj = null;

    this.show = function (obj) {

        this.obj = ( (typeof obj !== "undefined" ) ? obj : null );

        var selector = obj.selector;
        var scopeBlock = obj.scopeBlock;

        var options = {
            width: obj.width,
            height: obj.height
        };

        var callbacks = {
            onAfterShowModalForm: this.createAllStructure,
            onAfterCloseModalForm: this.afterCloseModalForm
        };

        this.modalForm = new Monet.Form.Modal(selector, options, callbacks, scopeBlock);

        this.modalForm.showModalForm();
    };

    this.prepareModal = function () {

        var modalContainer = document.querySelector(this.obj.selector + " .popupFormContainer");
        var error;

        if (modalContainer) {

            try {

                this.generateModalContent();

            } catch (e) {

                error = new Monet.Exception.ReturnError(this, "No add form equipment to modal.");
                error.console();

            }


        } else {

            error = new Monet.Exception.ReturnError(this, "No modal to add form equipment.");
            error.console();

        }

    };

    this.generateModalContent = function () {

        var signatureImg = document.createElement('img');
        signatureImg.src = 'resources/javascripts/views/Gallery/' + signature.url;

        $(".popupFormContainer").append(signatureImg);

    };

    this.closeModalWindow = function (scope) {

        return function () {
            scope.modalForm.closeModalWindow();
        };

    }(this);

    this.addEventListeners = function (scope) {

        this.listeners(scope);

    };

    this.iconLoading = function () {

        var classLoading = document.createElement('div');
        var iconImg = document.createElement('img');
        var popup;

        classLoading.setAttribute("class", "loadingPopupFormContainer");
        iconImg.src = require("static/images/general/loading_blue.svg");
        classLoading.appendChild(iconImg);

        popup = document.querySelectorAll(this.obj.selector + " .popupFormContainer");

        if (typeof popup[0] !== "undefined") {
            popup[0].appendChild(classLoading);
        }

    };

    this.removeIconLoading = function () {

        $(this.obj.selector + ' .loadingPopupFormContainer').remove();

    };

    this.replaceMediumImage = function (newImage) {

        $(".image img").remove();
        $(".containerImageLarge .image").append("<img src=" + newImage + ">");

    };

    this.listeners = function (scope) {

        var error;

        try {

            const request = new DefaultRequest({
                url: 'PhotoAlbum/Find',
                method: 'post',
                beforeSend: function () {
                    scope.iconLoading();
                },
                success: function (data) {

                    $('.loadingPopupFormContainer').remove();

                    fragment = scope.generateModalContent(data);

                },
                error: function (xhr) {

                    scope.errorCallback(xhr);

                }
            });
            request.send();

        } catch (e) {
            error = new Monet.Exception.ReturnError(this, "Image not found.", e);
            error.console();
        }

    };

    this.errorCallback = function (data) {

        $('.loadingPopupFormContainer').remove();

        var monetInlineAlerContainer = document.createElement("div");
        var alert = document.createElement("div");
        var detailError = document.createElement("li");
        var error;

        alert.setAttribute("class", "alert alert-error");
        alert.style.marginBottom = "20px";
        alert.style.marginLeft = "25%";
        alert.style.marginTop = "10%";
        alert.style.display = "block";


        alert.style.marginLeft = "2%";
        error = JSON.parse(data.responseText);
        detailError.innerHTML = "Error: " + Monet.Form.Messages.getErrorMessageToBeDisplayed(error.errorMessages);

        alert.appendChild(detailError);

        monetInlineAlerContainer.appendChild(alert);

        $('.popupFormContainer').append(monetInlineAlerContainer);

    };

    this.createAllStructure = function (scope) {
        return function () {

            scope.addEventListeners(scope);
            scope.prepareModal();

        };
    }(this);

};
